<!--
수기확인처리 (예치금이 아닌경우, 강제로 확인처리 수정
------------------------------------
-->
<template>
    <!-- 폼 화면 -->

    <div class="confirm-overlay" ref="confirm-overlay" v-show="display">
        <div class="confirm-dialog p-1rem">


            <div class="mt-1rem uk-flex uk-flex-between uk-flex-bottom">
                <div class="font-bold text-black">
                    예치금 입금이 아닌경우, 수기확인처리 (비고작성)
                </div>

            </div>

            <table class="info-table small uk-width-1-1 border-highlight mt-1rem">
                <colgroup>
                    <col style="width: 9rem">
                    <col>
                </colgroup>

                <tr>
                    <th class="uk-text-right">
                        거래일(입금일)
                    </th>
                    <td>
                        {{ transaction.transaction_at }}
                    </td>

                </tr>
                <tr>
                    <th class="uk-text-right">
                        입금자명
                    </th>
                    <td>
                        {{ transaction.deposit_name }}
                    </td>

                </tr>
                <tr>
                    <th class="uk-text-right">
                        금액
                    </th>
                    <td>
                        {{ transaction.amount }}
                    </td>

                </tr>

                <tr>
                    <th class="uk-text-right">
                        비고
                    </th>
                    <td>
                        <app-input-textarea
                            :textarea-rows="3"
                            placeholder="수기로 확인처리하는 사유를 작성하세요"

                            v-model.trim="inputs.memo"
                        ></app-input-textarea>
                    </td>

                </tr>


            </table>

            <div class="uk-text-right mt-1rem">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default"

                    @click="hideForm"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>


                <button
                    type="button"
                    class="uk-button uk-button-danger"

                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    입금확인(수기)
                </button>
            </div>

        </div>
    </div>

</template>

<script>

export default {
    mixins: [
    ],
    props: {
        // csrf-token
        csrfToken: String,
    },
    data: function () {
        return {
            // (bool) 폼 display 여부
            display: false,

            // (object) 거래정보
            transaction: {},

            /**
             * 입력값
             */
            inputs: {
                memo: null,
            },
        };
    },
    mounted: function () {
        //console.log('mounted in component');
    },
    computed: {
    },
    methods: {
        /**
         * 입력폼 display
         */
        displayForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            document.body.appendChild(this.$refs['confirm-overlay']);
            this.display = true;
        },

        /**
         * 입력폼 hide
         */
        hideForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            this.display = false;
        },

        /**
         * 폼 띄우기
         */
        form(transaction_id) {
            // 초기화
            this.inputs = {
                memo: null,
            };

            // promise 생성
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/bank-transactions/' + transaction_id,
                    contentType: 'application/json',
                    data: {},
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            });


            // promise 처리
            load.then((response) => {
                this.transaction = response.transaction;

                this.inputs.memo = this.transaction.memo;

                //console.log(response);
                // 폼띄우기
                this.displayForm();
            });
        },

        /**
         * 서브밋 전 검증
         * @return Promise
         */
        submitValidation() {
            return new Promise((resolve, reject) => {
                // 입력값 검증
                if (! this.inputs.memo) {
                    reject('비고작성은 필수입니다.');
                    return;
                }

                resolve();
            });


        },

        /**
         * submit
         */
        submit() {
            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/bank-transactions/' + this.transaction.id + '/manual-check',
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                this.display = false;
                UIkit.modal.alert(response.msg).then(() => {
                    // 완료이벤트
                    this.$emit('done');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },

    },
}
</script>

<style lang="scss" scoped>


// 컨펌화면
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .confirm-dialog {
        width: 40rem;
        max-width: 90%;

        background-color: #fff;

    }
}
</style>